import "./style.scss";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import APPopUp from "@/src/components/ApplicationsPage/APPopUp/APPopUp";
import APHeader from "@/src/components/ApplicationsPage/APHeader/APHeader";
import APBody from "@/src/components/ApplicationsPage/APBody/APBody";
import APFooter from "@/src/components/ApplicationsPage/APFooter/APFooter";
import { RootState } from "@/src/store";
import { IFiltersList, IRowData } from "@/src/types/applicationOnline";
import ApplyOnline from "../ApplyOnline/ApplyOnline";
import { applicationPageRequests } from "@/src/api/applicationPageRequests";
import { setData } from "@/src/store/slices/ApplicationPage/applicationsTableSlice";
import { useFilteredObject } from "@/src/hooks/useFilteredObject";
import { setIsPreloyder } from "@/src/store/slices/Preloyder/PreloyderSlice";

const APLayout = () => {
  const dispatch = useDispatch();

  let actualOfficeTable = useSelector((state: RootState) => state.applicationsFilters.actualOfficeTable);
  const bodyFilters = useSelector((state: RootState) => state.applicationsFilters.filterResults);
  const actualFilterStatus = useSelector((state: RootState) => state.applicationsFilters.filterStatus);

  const headerCheckboxRef = useRef<HTMLInputElement>(null);

  const [isShowSettingsModal, setIsShowSettingsModal] = useState(false);
  const [isApPopUpFullName, setIsApPopUpFullName] = useState<boolean>(false);
  const [currentDataPopUp, setCurrentDataPopUp] = useState<IRowData | undefined>();
  const [isCurrentPage, setIsCurrentPage] = useState<string>("1");
  const [isSelectPagination, setIsSelectPagination] = useState<string>("5");

  const [tableFiltersList, setTableFiltersList] = useState<IFiltersList | undefined>();

  const [actualQuantityRows, setActualQuantityRows] = useState<number>(0);

  const bodyFilterFetch = useFilteredObject(bodyFilters);

  const formRef = useRef<HTMLDivElement>(null);

  const updateShowFormClass = () => {
    if (formRef.current) {
      const value = localStorage.getItem("applyOnlineApplications");
      if (value === "show") formRef.current.classList.add("show");
      else formRef.current.classList.remove("show");
    }
  };

  // const loadActualForm = async () => {
  //   dispatch(setIsPreloyder(true));
  //   let offsetTableRow = Number(isSelectPagination) * (Number(isCurrentPage) - 1);
  //   let dataTable;
  //   let dataTableFilter;
  //   if (Object.keys(bodyFilterFetch).length === 0) {
  //     dataTable = await applicationPageRequests.getList(isSelectPagination, offsetTableRow, actualOfficeTable);
  //   } else {
  //     dataTable = await applicationPageRequests.getList(isSelectPagination, offsetTableRow, actualOfficeTable, bodyFilterFetch);
  //   }
  //   dataTableFilter = await applicationPageRequests.getFilterList(actualOfficeTable);
  //   if (dataTable && dataTableFilter) {
  //     dispatch(setData(dataTable));
  //     setTableFiltersList(dataTableFilter);
  //     setActualQuantityRows(dataTable.count_form);
  //   }
  //   dispatch(setIsPreloyder(false));
  // };

  const loadActualForm = async () => {
    dispatch(setIsPreloyder(true));

    try {
      let offsetTableRow = Number(isSelectPagination) * (Number(isCurrentPage) - 1);

      const dataTable =
        Object.keys(bodyFilterFetch).length === 0
          ? await applicationPageRequests.getList(isSelectPagination, offsetTableRow, actualOfficeTable)
          : await applicationPageRequests.getList(isSelectPagination, offsetTableRow, actualOfficeTable, bodyFilterFetch);

      const dataTableFilter = await applicationPageRequests.getFilterList(actualOfficeTable);

      if (dataTable && dataTableFilter) {
        dispatch(setData(dataTable));
        setTableFiltersList(dataTableFilter);
        setActualQuantityRows(dataTable.count_form);
      }
    } catch (error) {
      alert("An unexpected error occurred - write to the developers");
      console.error(error);
    } finally {
      dispatch(setIsPreloyder(false));
    }
  };

  useEffect(() => {
    loadActualForm();

    window.addEventListener("applyOnlineApplicationsChanged", updateShowFormClass);

    return () => {
      window.removeEventListener("applyOnlineApplicationsChanged", updateShowFormClass);
    };
  }, [isCurrentPage, isSelectPagination, actualOfficeTable, bodyFilters]);

  useEffect(() => {
    setIsCurrentPage("1");
  }, [actualOfficeTable, actualFilterStatus]);

  return (
    <>
      <div ref={formRef} className="applications-page-form">
        <ApplyOnline loadActualForm={loadActualForm} />
      </div>

      <div className="container applications-page">
        <APPopUp isApPopUpFullName={isApPopUpFullName} setIsApPopUpFullName={setIsApPopUpFullName} currentDataPopUp={currentDataPopUp} />
        <APHeader
          isShowSettingsModal={isShowSettingsModal}
          setIsShowSettingsModal={setIsShowSettingsModal}
          loadActualForm={loadActualForm}
        />
        <APBody
          headerCheckboxRef={headerCheckboxRef}
          setIsApPopUpFullName={setIsApPopUpFullName}
          setCurrentDataPopUp={setCurrentDataPopUp}
          tableFiltersList={tableFiltersList}
          isShowSettingsModal={isShowSettingsModal}
        />
        <APFooter
          isCurrentPage={isCurrentPage}
          setIsCurrentPage={setIsCurrentPage}
          isSelectPagination={isSelectPagination}
          setIsSelectPagination={setIsSelectPagination}
          actualQuantityRows={actualQuantityRows}
        />
      </div>
    </>
  );
};

export default APLayout;
